var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-pagination',{attrs:{"current-page":_vm.search.page,"page-size":_vm.search.size,"total":_vm.total,"background":"","layout":"total, prev, pager, next, jumper"},on:{"current-change":_vm.changeCurrent}})}
var staticRenderFns = []

export { render, staticRenderFns }